import React from "react";
import ThemeWrapper from "../../components/ThemeWrapper";
import { Container } from "react-bootstrap";

const PublicRoute = ({
  redirectPath = "/",
  component: Component,
  ...otherProps
}) => {
  return (
    <Container fluid>
      <ThemeWrapper>
        <Component {...otherProps} />
      </ThemeWrapper>
    </Container>
  );
};

export default PublicRoute;
